<div class="dashboard-content">
  <div class="main-panel">
    <div class="content-wrapper">
      
      <div class="dashboard-header">
        <mat-label>System Overview</mat-label>
        <div id="card-group">
          <mat-card class="dashboard-card-total" (click)="navigateToUsers()">
            <mat-card-content>
              <div id="mticon">
                <mat-icon>people</mat-icon>
              </div>
              <p>Total Users</p>
              <div id="val">{{ totalUsers || 0 }}</div>
              <div id="arrow">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="dashboard-card-degree" (click)="navigateToInstitutions()">
            <mat-card-content>
              <div id="mticon">
                <mat-icon>business</mat-icon>
              </div>
              <p>Active Institutions</p>
              <div id="val">{{ totalInstitutions || 0 }}</div>
              <div id="arrow">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="dashboard-card-diploma" (click)="navigateToSystemLogs()">
            <mat-card-content>
              <div id="mticon">
                <mat-icon>bug_report</mat-icon>
              </div>
              <p>System Alerts</p>
              <div id="val">{{ systemAlerts || 0 }}</div>
              <div id="arrow">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="dashboard-card-certificate" (click)="navigateToBackups()">
            <mat-card-content>
              <div id="mticon">
                <mat-icon>backup</mat-icon>
              </div>
              <p>Last Backup</p>
              <div id="val">{{ lastBackupDays || 0 }}d</div>
              <div id="arrow">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <!-- Quick Actions Section -->
      <div class="total-header">
        <mat-label>Quick Actions</mat-label>
      </div>

      <div class="card-container">
        <div class="dashboard-col-2">
          <div class="mat-card-green" (click)="createNewInstitution()">
            <a>
              <mat-icon>add_business</mat-icon>
              Create New Institution
            </a>
          </div>
          <div class="mat-card-yellow" (click)="manageSystemSettings()">
            <a>
              <mat-icon>settings</mat-icon>
              System Settings
            </a>
          </div>
          <div class="mat-card-red" (click)="viewSystemReports()">
            <a>
              <mat-icon>analytics</mat-icon>
              System Reports
            </a>
          </div>
        </div>

        <div class="dashboard-col-2">
          <div class="mat-card-green" (click)="manageUserRoles()">
            <a>
              <mat-icon>admin_panel_settings</mat-icon>
              Manage User Roles
            </a>
          </div>
          <div class="mat-card-yellow" (click)="viewAuditLogs()">
            <a>
              <mat-icon>history</mat-icon>
              Audit Logs
            </a>
          </div>
          <div class="mat-card-red" (click)="systemMaintenance()">
            <a>
              <mat-icon>build</mat-icon>
              System Maintenance
            </a>
          </div>
        </div>

        <div class="dashboard-col-2">
          <div class="mat-card-green" (click)="databaseBackup()">
            <a>
              <mat-icon>cloud_upload</mat-icon>
              Database Backup
            </a>
          </div>
          <div class="mat-card-yellow" (click)="securityMonitoring()">
            <a>
              <mat-icon>security</mat-icon>
              Security Monitor
            </a>
          </div>
          <div class="mat-card-red" (click)="emergencyActions()">
            <a>
              <mat-icon>warning</mat-icon>
              Emergency Actions
            </a>
          </div>
        </div>
      </div>

      <!-- Recent Activity Section -->
      <div class="total-header">
        <mat-label>Recent System Activity</mat-label>
      </div>

      <div id="table-block">
        <div class="table-container">
          <table mat-table [dataSource]="recentActivities" class="mat-elevation-z1">
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Timestamp</th>
              <td mat-cell *matCellDef="let activity" data-label="Timestamp">
                {{ activity.timestamp | date:'medium' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>User</th>
              <td mat-cell *matCellDef="let activity" data-label="User">
                {{ activity.userName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let activity" data-label="Action">
                {{ activity.action }}
              </td>
            </ng-container>

            <ng-container matColumnDef="institution">
              <th mat-header-cell *matHeaderCellDef>Institution</th>
              <td mat-cell *matCellDef="let activity" data-label="Institution">
                {{ activity.institutionName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let activity" data-label="Status">
                <span [ngClass]="getStatusClass(activity.status)">
                  {{ activity.status }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let activity" data-label="Actions">
                <button mat-icon-button (click)="viewActivityDetails(activity)" 
                        matTooltip="View Details">
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[10, 25, 50]" 
                         [pageSize]="10"
                         showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>

      <!-- System Health Section -->
      <div class="secondRow">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>monitor_heart</mat-icon>
              System Health
            </mat-panel-title>
            <mat-panel-description>
              Current system status and performance metrics
            </mat-panel-description>
          </mat-expansion-panel-header>
          
          <div class="system-health-content">
            <div class="health-metric">
              <span class="metric-label">CPU Usage:</span>
              <mat-progress-bar mode="determinate" [value]="systemHealth?.cpuUsage || 0">
              </mat-progress-bar>
              <span class="metric-value">{{ systemHealth?.cpuUsage || 0 }}%</span>
            </div>
            
            <div class="health-metric">
              <span class="metric-label">Memory Usage:</span>
              <mat-progress-bar mode="determinate" [value]="systemHealth?.memoryUsage || 0">
              </mat-progress-bar>
              <span class="metric-value">{{ systemHealth?.memoryUsage || 0 }}%</span>
            </div>
            
            <div class="health-metric">
              <span class="metric-label">Database Response:</span>
              <span class="metric-value" [ngClass]="getDatabaseHealthClass()">
                {{ systemHealth?.dbResponseTime || 0 }}ms
              </span>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>notifications</mat-icon>
              System Notifications
            </mat-panel-title>
            <mat-panel-description>
              Important system alerts and notifications
            </mat-panel-description>
          </mat-expansion-panel-header>
          
          <div class="notifications-content">
            <div *ngFor="let notification of systemNotifications" 
                 class="notification-item"
                 [ngClass]="'notification-' + notification.type">
              <mat-icon>{{ getNotificationIcon(notification.type) }}</mat-icon>
              <div class="notification-text">
                <strong>{{ notification.title }}</strong>
                <p>{{ notification.message }}</p>
                <small>{{ notification.timestamp | date:'short' }}</small>
              </div>
            </div>
            
            <div *ngIf="!systemNotifications || systemNotifications.length === 0" 
                 class="no-notifications">
              <mat-icon>check_circle</mat-icon>
              <p>No active system notifications</p>
            </div>
          </div>
        </mat-expansion-panel>
      </div>

    </div>
  </div>
</div>